'use client';

import { GoogleTagManager } from '@next/third-parties/google';
import Script from 'next/script';

import DriftWidget from '@/app/components/ui/Drift/DriftWidget';

export default function ThirdPartyScripts({ gtmId }: { gtmId: string }) {
  return (
    <>
      <GoogleTagManager gtmId={gtmId} />

      {/* 6sense Cookieless Web Tag - Fires regardless of consent */}
      <Script 
        id="6senseWebTag" 
        src="https://j.6sc.co/j/7f3589a4-bb3e-4421-a50a-af157d9ab112.js"
        strategy="afterInteractive"
      />

      <DriftWidget />

      {/* Note: Chili Piper is managed by useChiliPiper hook */}

      {/* HubSpot Tracking Script - Manually blocked by Concord until analytics consent is given */}
      <script 
        type="text/plain"
        data-concord-type="text/javascript"
        data-concord-modified="blocked"
        data-concord-category="analytics"
        id="hs-script-loader" 
        async 
        defer 
        data-concord-src="//js.hs-scripts.com/7288424.js"
      />
    </>
  );
}